import { Injectable } from '@angular/core';
import { Observable, fromEvent, shareReplay } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ShutdownService {
    beforeShutdown$: Observable<Event>;
    private readonly SHUTDOWN_EVENT_NAME = 'beforeunload';

    constructor() {
        this.beforeShutdown$ = fromEvent(window, this.SHUTDOWN_EVENT_NAME).pipe(shareReplay(1));
    }
}
